module.exports = __webpack_public_path__ + "static/img/Inspiron_15_7560.cc200052.png";